// extracted by mini-css-extract-plugin
export default {"modal":"modal-uo2_","container":"container-ugNU","intro":"intro-hh8_","icon":"icon-Ad1b","noise":"noise-XCbo","content":"content-ICSd","actions":"actions-c27z","more":"more-lob5"};